import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { News } from 'src/app/models/news';

@Injectable({
  providedIn: 'root'
})
export class NewsApiClientService extends ApiClientService<News> {
  endpoint = 'news';
}

